import { createContext, useState } from 'react';

const DrawerContext = createContext({
  open: false,
  drawer: 'none',
  details: {},
  setDetails: (setDetails) => {},
  openDrawer: (openDrawer) => {},
  closeDrawer: (closeDrawer) => {}
});

export function DrawerContextProvider(props) {

  const [open, setOpen] = useState(false);
  const [drawer, setDrawer] = useState('none');
  const [details, setDetails] = useState({});

  function openDrawerHandler() {
    setOpen(true);
  }

  function closeDrawerHandler() {
    setOpen(false);
  }

  function setDetailsHandler(drawer, data) {
    setDrawer(drawer);
    setDetails(data);
  }

  const context = {
    open: open,
    drawer: drawer,
    details: details,
    setDetails: setDetailsHandler,
    openDrawer: openDrawerHandler,
    closeDrawer: closeDrawerHandler
  };

  return <DrawerContext.Provider value={context}>
    {props.children}
  </DrawerContext.Provider>
}

export default DrawerContext;